"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BrandLoader = _interopRequireDefault(require("./BrandLoader"));

var _Brand = _interopRequireDefault(require("./Brand"));

require("../styles/_brands.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function onSelect(action, brandId) {
  return function () {
    action(brandId);
  };
}

function Brands(_ref) {
  var selectedBrandId = _ref.selectedBrandId,
      brands = _ref.brands,
      onSelectBrand = _ref.onSelectBrand,
      canUpdateVideo = _ref.canUpdateVideo;

  if (!brands) {
    return (/*#__PURE__*/_react.default.createElement(_BrandLoader.default, null)
    );
  }

  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "brands"
    }, !brands.length ? /*#__PURE__*/_react.default.createElement("p", {
      className: "brands__empty"
    }, 'Your Organisation doesn\'t have any brands yet.') : null, brands.map(function (_ref2) {
      var subBrandId = _ref2.subBrandId,
          coverImageKey = _ref2.coverImageKey,
          name = _ref2.name,
          updatedAt = _ref2.updatedAt;
      return (/*#__PURE__*/_react.default.createElement(_Brand.default, {
          key: subBrandId,
          subBrandId: subBrandId,
          imageUrl: coverImageKey,
          name: name,
          updatedAt: updatedAt,
          selected: selectedBrandId === subBrandId,
          onSelect: onSelect(onSelectBrand, subBrandId),
          canUpdateVideo: canUpdateVideo
        })
      );
    }))
  );
}

var _default = (0, _react.memo)(Brands);

exports.default = _default;